import { type ProductBlock } from 'src/types/contentBlocks';

import { renderBlocks } from './renderBlocks';

type PageBlocksProps = {
  blocks: ProductBlock[];
  onConsultationClick?: () => void;
};

export function PageBlocks({
  blocks = [],
  onConsultationClick,
}: PageBlocksProps) {
  return renderBlocks(blocks)(onConsultationClick);
}
